import { doc, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

// Saves a goal's open tasks in the order given as goalTaskOrder 1, 2, 3… (the goal page's Your order, and the order the
// Goals page lists them in), in one batch, writing only the tasks whose place changed. Updates, never merges: a task
// deleted on another device fails the batch instead of coming back as an empty task.
export const writeGoalTaskOrder = (uid, orderedTasks) => {
  const changed = orderedTasks.map((t, i) => [t, i + 1]).filter(([t, place]) => t.goalTaskOrder !== place);
  if (!changed.length) return Promise.resolve();
  const batch = writeBatch(db);
  changed.forEach(([t, place]) => batch.update(doc(db, "users", uid, "tasks", t.id), { goalTaskOrder: place, updatedAt: serverTimestamp() }));
  return batch.commit();
};
